"use strict";

exports.__esModule = true;

var _StaticRouter = require("react-router/StaticRouter");

var _StaticRouter2 = _interopRequireDefault(_StaticRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-dom/StaticRouter.js
 ** module id = 760
 ** module chunks = 0
 **/